module.exports = __webpack_public_path__ + "img/icon-header-lang.d79e853d.svg";